import React from 'react'
import classNames from 'classnames'
import classes from './CourseOutlineProgressCard.module.css'
import { Card } from '../GeneralCard/Card'
import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg'
import { useLocation } from 'react-router'
import { getParentRoute } from '../../../util/functions'
import { Link } from 'react-router-dom'

const ProgressCheckboxStates = Object.freeze({
    Upcoming: 'UPCOMING',
    Done: 'DONE',
    Current: 'CURRENT',
})

const ProgressCheckbox = ({
    className,
    state = ProgressCheckboxStates.Upcoming,
    forTopic = true,
}) => {
    let label = ''
    if (forTopic) {
        label = 'Upcoming topic: '
        if (state === ProgressCheckboxStates.Done) label = 'Completed topic: '
        else if (state === ProgressCheckboxStates.Current)
            label = 'Current topic: '
    } else {
        label = 'Current section: '
        if (state === ProgressCheckboxStates.Done) label = 'Completed section: '
    }
    let activeClassName = null
    if (state === ProgressCheckboxStates.Done)
        activeClassName = classes.progressCheckboxChecked
    else if (state === ProgressCheckboxStates.Current)
        activeClassName = classes.progressCheckboxCurrent
    return (
        <div
            className={classNames(
                classes.progressCheckbox,
                activeClassName,
                className
            )}
            aria-label={label}
        >
            {!!activeClassName && (
                <span className={classes.progressCheckboxInner}>
                    {state === ProgressCheckboxStates.Done && <CheckIcon />}
                </span>
            )}
        </div>
    )
}

const TopicItem = ({ topic, isCurrentTopic }) => {
    let checkboxState = ProgressCheckboxStates.Upcoming
    if (isCurrentTopic) checkboxState = ProgressCheckboxStates.Current
    else if (topic.completed) checkboxState = ProgressCheckboxStates.Done
    const { pathname } = useLocation()
    const lectureURL = getParentRoute(pathname)
    return (
        <Link
            to={`${lectureURL}/${topic.topicid}`}
            aria-label={`View lecture ${topic.title}`}
            className={classes.topicItem}
        >
            <div className={classes.topicItemCheckboxWrapper}>
                <ProgressCheckbox state={checkboxState} />
            </div>
            <div className={classes.topicItemDivider} />
            <div className={classes.topicItemTextWrapper}>
                <p
                    className={classNames(
                        classes.topicItemText,
                        isCurrentTopic && classes.topicItemTextActive
                    )}
                >
                    {topic.title}
                </p>
            </div>
        </Link>
    )
}

const SectionOutline = ({ section, topics, currentTopic }) => {
    const allTopicsDone = !topics?.some(topic => !topic.completed)
    const topicCounts = {
        completed: topics?.filter(topic => topic.completed)?.length || 0,
        all: topics?.length || 0,
    }
    return (
        <div className={classes.sectionOutline}>
            <div className={classes.sectionTitleWrapper}>
                <ProgressCheckbox
                    className={classes.sectionTitleCheckbox}
                    state={
                        allTopicsDone
                            ? ProgressCheckboxStates.Done
                            : ProgressCheckboxStates.Upcoming
                    }
                />
                <h4 className={classes.sectionTitle}>
                    {section.title}
                    <br />({topicCounts.completed}/{topicCounts.all})
                </h4>
            </div>
            {topics?.map(topic => (
                <TopicItem
                    key={topic.topicid}
                    topic={topic}
                    isCurrentTopic={`${topic.topicid}` === `${currentTopic}`}
                />
            ))}
        </div>
    )
}

const CourseOutlineProgressCard = ({
    sections,
    topics,
    currentTopic = null,
    className,
    ...props
}) => {
    return (
        <Card className={classNames(classes.outlineCard, className)} {...props}>
            <h3 className={classes.outlineCardTitle}>Course Content</h3>
            {sections.map(section => {
                const sectionTopics = section.topics
                return (
                    <SectionOutline
                        key={section.lessonid}
                        section={section}
                        topics={sectionTopics}
                        currentTopic={currentTopic}
                    />
                )
            })}
        </Card>
    )
}

export default CourseOutlineProgressCard
